import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {SORT_ICONS, SORT_LABEL_MAPS} from './constants';
import template from './index.jade';
import './index.styl';

const ORDER_DIRECTIONS = [`asc`, `desc`];

export class HeaderSortMenu extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'sort-by-options': {type: `json`, default: []},
      'sort-config': `json`,
    };
  }

  get config() {
    return {
      template,
      helpers: {
        getSortItems: () => this._getSortItems(this.attr(`sort-by-options`)),
        onSelectSortItem: (ev) => {
          const {sortBy, sortOrder} = ev.detail.item;
          this.dispatchEvent(
            new CustomEvent(`selectSortItem`, {
              detail: {sortBy, sortOrder},
            }),
          );
        },
      },
    };
  }

  _getSortItems(sortByOptions) {
    const items = [];

    sortByOptions.forEach((option) => {
      ORDER_DIRECTIONS.forEach((order) => {
        const optionDisplayName = SORT_ICONS[option];
        const sortConfig = this.attr(`sort-config`) || {};
        items.push({
          label: SORT_LABEL_MAPS[option][order],
          sortBy: option,
          sortOrder: order,
          isSelected: sortConfig.sortBy === option && sortConfig.sortOrder === order,
          icon: `sort-${optionDisplayName}-${order}`,
        });
      });
    });

    return items;
  }
}
export const HeaderSortMenuEl = defineAndMakeJsxFactory(`header-sort-menu`, HeaderSortMenu);
